/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HealthCheckEntryViewModel
 */
export interface HealthCheckEntryViewModel {
    /**
     * 
     * @type {string}
     * @memberof HealthCheckEntryViewModel
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HealthCheckEntryViewModel
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HealthCheckEntryViewModel
     */
    status?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HealthCheckEntryViewModel
     */
    statusDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HealthCheckEntryViewModel
     */
    executionTime?: string | null;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof HealthCheckEntryViewModel
     */
    context?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the HealthCheckEntryViewModel interface.
 */
export function instanceOfHealthCheckEntryViewModel(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function HealthCheckEntryViewModelFromJSON(json: any): HealthCheckEntryViewModel {
    return HealthCheckEntryViewModelFromJSONTyped(json, false);
}

export function HealthCheckEntryViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): HealthCheckEntryViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'statusDescription': !exists(json, 'statusDescription') ? undefined : json['statusDescription'],
        'executionTime': !exists(json, 'executionTime') ? undefined : json['executionTime'],
        'context': !exists(json, 'context') ? undefined : json['context'],
    };
}

export function HealthCheckEntryViewModelToJSON(value?: HealthCheckEntryViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
        'status': value.status,
        'statusDescription': value.statusDescription,
        'executionTime': value.executionTime,
        'context': value.context,
    };
}

